import React from 'react';
import { ClassroomsProvider } from '@teetsh/app/src/containers/App/context/ClassroomsContext';

import { Outlet } from 'react-router-dom';
import { PageTrackerWrapper } from '@teetsh/app/src/queries/user/track';
import { TemplatePicker } from '@teetsh/app/src/containers/EmploiDuTemps/New/TemplatePicker';
import { NewEDTPage } from '@teetsh/app/src/containers/EmploiDuTemps/New';
import EDT from '@teetsh/app/src/containers/EmploiDuTemps/EDT';
import { EmploiDuTempsList } from '@teetsh/app/src/containers/EmploiDuTemps/List';
import { FromOld } from '@teetsh/app/src/containers/EmploiDuTemps/New/FromOld';
import { PreviewOld } from '@teetsh/app/src/containers/EmploiDuTemps/New/PreviewOld';
import { TitleHelmet } from '@teetsh/app/src/components/TitleHelmet/TitleHelmet';
import { EDTPreview } from '@teetsh/app/src/containers/EmploiDuTemps/Preview';
import { EventCustomFieldDefinitionsProvider } from 'containers/App/context/EventCustomFieldDefinitionsContext/EventCustomFieldDefinitionsProvider';

export const EmploiDuTempsRoutes = {
  path: 'emploi-du-temps',
  element: (
    <>
      <TitleHelmet titleKey="sidebar.emploiDuTemps" />
      <ClassroomsProvider>
        <Outlet />
      </ClassroomsProvider>
    </>
  ),
  children: [
    {
      path: 'new/from-old',
      element: (
        <PageTrackerWrapper title="EDT - nouveau - à partir d'un autre">
          <FromOld />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'new/preview-old',
      element: (
        <PageTrackerWrapper title="EDT - nouveau - à partir d'un autre - preview">
          <PreviewOld />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'new/with-template',
      element: (
        <PageTrackerWrapper title="EDT - nouveau - avec modèle">
          <TemplatePicker />
        </PageTrackerWrapper>
      ),
    },
    {
      path: 'new',
      element: (
        <PageTrackerWrapper title="EDT - nouveau">
          <NewEDTPage />
        </PageTrackerWrapper>
      ),
    },
    {
      path: ':emploiDuTempsId',
      children: [
        {
          index: true,
          element: (
            <PageTrackerWrapper title="EDT">
              <EventCustomFieldDefinitionsProvider>
                <EDT />
              </EventCustomFieldDefinitionsProvider>
            </PageTrackerWrapper>
          ),
        },
        {
          path: 'preview',
          element: (
            <PageTrackerWrapper title="EDT - preview">
              <EDTPreview />
            </PageTrackerWrapper>
          ),
        },
      ],
    },
    {
      index: true,
      element: (
        <PageTrackerWrapper title="EDT - liste">
          <EmploiDuTempsList />
        </PageTrackerWrapper>
      ),
    },
  ],
};
